import React from 'react';
import { Menu } from './Menu';
import { MenuItem } from './MenuItem';
interface AdminLayoutProps {
  children: React.ReactNode;
}

export const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
  return (
    <div className="bg-customBg flex">
      <Menu>
        <MenuItem to="/admin/property">物件</MenuItem>
        <MenuItem to="/admin/contract">申し込み</MenuItem>
        <MenuItem to="/admin/magazine">マガジン</MenuItem>
        {/* <MenuItem to="/admin/news">ニュース</MenuItem> */}
      </Menu>
      <div className="bg-yellow pt-6 p-[40px] w-full">{children}</div>
    </div>
  );
};
